import { Ingredient } from '../types';

export interface MealMacroSummary {
  kcal: number;
  macro: {
    protein: { grams: number; percentage: number };
    fat: { grams: number; percentage: number };
    carbohydrates: { grams: number; percentage: number };
  };
}

/**
 * Oblicza sumę kcal i makro (białko, tłuszcze, węgle) z tablicy składników.
 */
export function calculateMacrosFromIngredients(ingredients: Ingredient[]): MealMacroSummary {
  const totalMacro = {
    protein: { grams: 0, percentage: 0 },
    fat: { grams: 0, percentage: 0 },
    carbohydrates: { grams: 0, percentage: 0 },
  };

  let totalKcal = 0;

  ingredients.forEach((ingredient) => {
    totalKcal += ingredient.kcal;
    if (ingredient.macro) {
      totalMacro.protein.grams += ingredient.macro.protein.grams;
      totalMacro.fat.grams += ingredient.macro.fat.grams;
      totalMacro.carbohydrates.grams += ingredient.macro.carbohydrates.grams;
    }
  });

  if (totalKcal > 0) {
    totalMacro.protein.percentage = Math.round(((totalMacro.protein.grams * 4) / totalKcal) * 100);
    totalMacro.fat.percentage = Math.round(((totalMacro.fat.grams * 9) / totalKcal) * 100);
    totalMacro.carbohydrates.percentage = Math.round(
      ((totalMacro.carbohydrates.grams * 4) / totalKcal) * 100
    );
  }

  return {
    kcal: totalKcal,
    macro: {
      protein: {
        grams: Math.round(totalMacro.protein.grams * 10) / 10,
        percentage: totalMacro.protein.percentage,
      },
      fat: {
        grams: Math.round(totalMacro.fat.grams * 10) / 10,
        percentage: totalMacro.fat.percentage,
      },
      carbohydrates: {
        grams: Math.round(totalMacro.carbohydrates.grams * 10) / 10,
        percentage: totalMacro.carbohydrates.percentage,
      },
    },
  };
}
